<div class="container" *ngIf="!loading; else loadingTpl">
  <h1>Resource Packs</h1>

  <mat-card class="card">
    <h2>Rebuild Core Pack</h2>
    <p>Rebuilds the core resource pack and updates the live settings (URL + hash).</p>
    <button mat-raised-button color="primary" (click)="rebuildCore()">Rebuild Core Pack</button>
  </mat-card>

  <mat-card class="card">
    <h2>Build Pack From Categories</h2>
    <p>Provide a comma separated list of category IDs to include in the pack.</p>
    <mat-form-field appearance="outline" class="full">
      <mat-label>Category IDs</mat-label>
      <input matInput placeholder="e.g. 1,2,3" [(ngModel)]="categoriesInput" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="full">
      <mat-label>Description (optional)</mat-label>
      <input matInput placeholder="Pack description" [(ngModel)]="description" />
    </mat-form-field>

    <button mat-raised-button color="accent" (click)="buildCustom()">Build Pack</button>
  </mat-card>

  <mat-card class="card" *ngIf="lastResult">
    <h2>Result</h2>
    <div *ngIf="lastResult.asset">Asset ID: <code>{{ lastResult.asset }}</code></div>
    <div *ngIf="lastResult.hash">SHA1: <code>{{ lastResult.hash }}</code></div>
  </mat-card>
</div>

<ng-template #loadingTpl>
  <div class="loading">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
  <p style="text-align:center">Processing...</p>
</ng-template>
